export default __webpack_public_path__ + "fonts/qrcode.ebcae3736f9bcd98162ba36ac2dfa707.png";